import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import API from './api.js';

const Virtual_Icon_Map = {
    classic: 'icon-3d-template4',
    fashion: 'icon-3d-template4',
    standard: 'icon-3d',
    layout1: "icon-3d-template4"
};
const Video_Icon_Map = {
    classic: 'icon-video',
    fashion: 'icon-video',
    standard: 'icon-video2',
    layout1: 'icon-video'
};

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['getMediaPopIns', 'getGalleryPopIns'],
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {}
        }),
        ...mapState({
            "theme": store => store.theme,
            "info": store => store.listingDetail.info || {},
            "hasFavor": store => store.hasFavor
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        tourBtnList({ info, theme }) {
            let { link, chimeVideoLink } = info;
            let list = [],
                virtualLinks = link ? link.split(' ') : [],
                videoLinks = chimeVideoLink ? chimeVideoLink.split(' ') : [];
            if (virtualLinks.length > 0) {
                list.push({
                    link: virtualLinks[0],
                    text: this.$t('md-detail-info.virtualTour'),
                    type: 'virtual',
                    icon: Virtual_Icon_Map[theme]
                });
            }
            if (videoLinks.length > 0) {
                list.push({
                    link: videoLinks[0],
                    text: this.$t('md-detail-info.videoTour'),
                    type: 'video',
                    icon: Video_Icon_Map[theme]
                });
            }
            return list;
        }
    },
    methods: {
        async handleTour(event, tour) {
            // const url = `https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0`
            const url = tour?.link;
            if (url) {
                const res = await API.getCanXFrame.call(this, url);
                if (!res?.data?.canXFrame) {
                    window.open(url, '_blank');
                    event.preventDefault();
                    return;
                }
            }

            if (this.isMobileSize) {
                const mediaPop = this.getMediaPopIns();
                const sourceData = mediaPop._getSource();
                let type = tour.type + 's';

                if (this.theme === 'layout1') {
                    if (type === 'virtuals') {
                        mediaPop?._openVirtualTourPop();
                    } else if (type === 'videos') {
                        mediaPop?._openVideoPop();
                    } 
                } else {
                    let index = sourceData[type].findIndex(val => {
                        return val.url === tour.link;
                    });
                    index = index != -1 ? index : 0;
                    if (type === 'virtuals') {
                        mediaPop?._openVirtualTourPop(index);
                    } else if (type === 'videos') {
                        mediaPop?._openVideoPop(index);
                    }
                }
            } else {
                const galleryPopIns = this.getGalleryPopIns();
                let type = tour.type + 's';
                if (type === 'virtuals') {
                    galleryPopIns?._openVirtualTourPop();
                } else if (type === 'videos') {
                    galleryPopIns?._openVideoPop();
                }
            }
            event.preventDefault();
        }
    }
};
